export class IncomingSMSCdrApiService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	search(params) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/search/", params).then(r => r.data);
	}
}